import {ShiftQuickSelectSlots} from '@hconnect/common/types'

export const SHIFT_QUICK_SELECT_SLOTS_OPTIMIZATION_SPECIALIST: ShiftQuickSelectSlots[] = [
  'currentShift',
  'pastShift',
  'today',
  'last24hours',
  'yesterday',
  'lastWeekend',
  'last3days',
  'last7days',
  'last30days'
]
